import { apiCreate } from './ApiBaseActions';
export const API_CREATE_PROFESSIONAL_REQUEST_SERVICE = 'API_CREATE_PROFESSIONAL_REQUEST_SERVICE';
/**
 * Proffitのサービス利用申請
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProfessionalRequestService = (data, meta) => apiCreate(API_CREATE_PROFESSIONAL_REQUEST_SERVICE, '/professional/request_service', data, meta || {});
